<template>
  <div class="flex h-full w-full flex-col justify-between text-left">
    <div class="flex-grow content-center text-left">
      <h1
        class="gc-font-title font-alternative mb-5 text-center text-xl md:mb-14">
        {{ $t('general.applySelectionToTitle') }}
      </h1>

      <h2
        class="font-alternative gc-font-notes mb-8 text-center md:mx-0 md:mb-14">
        {{ $t('general.applySelectionToSubTitle') }}
      </h2>

      <CustomCheckBox
        class="py-2.5 first:border-0"
        labelClass="!font-medium"
        :options="availableRoomsToGroup"
        @update:selectedOptions="updateSelectedValues" />
    </div>

    <div class="mb-5 mt-10 flex justify-around">
      <CustomButton
        class="custom-shadow w-full"
        :label="$t('general.done')"
        @click="selectAndCloseDrawer" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import CustomButton from '@/components/customComponents/CustomButton.vue';
import CustomCheckBox from '../customComponents/CustomCheckBox.vue';
import { useOffersStore } from '@stores/offers.store';
import { useReservationStore } from '@/stores/reservation.store';
import router from '@/router';
import { useRoute } from 'vue-router';
const route = useRoute();

const reservationStore = useReservationStore();
const offersStore = useOffersStore();
const { setCurrentRoom, groupToCurrentRoom, checkCurrentRoomSelected } =
  offersStore;
const { availableRoomsToGroup, currentRoom, multiRoomList } =
  storeToRefs(offersStore);

const emit = defineEmits(['hideMultiRoomDrawer']);
const selectedOptions = ref([]);

const selectAndCloseDrawer = () => {
  const options = selectedOptions.value;
  if (options.length > 0) {
    options.sort((a, b) => a - b);
    let lastRoomPosition = options.length - 1;
    for (let i in options) {
      reservationStore.cloneReservation(currentRoom.value, options[i]);
      groupToCurrentRoom(currentRoom.value, options[i]);
      lastRoomPosition = options[i];
    }
    setCurrentRoom(lastRoomPosition);
  }

  let newCurrentRoom;
  for (let m in multiRoomList.value) {
    if (!multiRoomList.value[m].selected) {
      newCurrentRoom = multiRoomList.value[m].identifier;
      break;
    }
  }

  emit('hideMultiRoomDrawer', true);
  if (newCurrentRoom === undefined) {
    router
      .push({
        name: 'guest details',
        query: route.query,
      })
      .then(() => {
        checkCurrentRoomSelected();
        window.scrollTo(0, 0);
      });
  } else {
    setCurrentRoom(newCurrentRoom);
    router
      .push({
        name: 'search',
        query: route.query,
      })
      .then(() => {
        window.scrollTo(0, 0);
      });
  }
};

const updateSelectedValues = (selectedValues) => {
  selectedOptions.value = selectedValues;
};
</script>

<style scoped>
:deep(.custom-checkbox) > label {
  @apply py-3;
  @apply border-border;
  @apply border-t-[1px];
}
:deep(.custom-checkbox) > label:first-of-type {
  @apply border-t-0;
}
</style>
